import { Id, Slide, toast, ToastContainer, ToastOptions, TypeOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaCheck } from "react-icons/fa";
import { HiShieldExclamation } from "react-icons/hi";

const renderIcon = (type: "success" | "error" | "clear" | "warning") => {
  switch (type) {
    case "success":
      return <FaCheck/>;
    case "error":
      return <HiShieldExclamation/>;
    default:
      return null;
  }
};

const FoundationsGenericToaster = (
  type: "success" | "error" | "clear" | "warning" = "success",
  message: string | JSX.Element = "",
  option: ToastOptions = {},
  toastId?: Id 
): Id | null => {

  const toastContent = (
    <div className={`toast-content ${type}`}>
      {renderIcon(type)}
      <span>{message}</span>
    </div>
  );

  let newToastId: Id = toastId || "";

  const toasterProps: ToastOptions = {
    position: option.position || "bottom-right",
    autoClose: option.autoClose ?? 2500,
    hideProgressBar: option.hideProgressBar ?? true,
    // newestOnTop: false,
    closeOnClick: true,
    closeButton: false,
    rtl: false,
    draggable: option.draggable ?? false,
    pauseOnHover: option.pauseOnHover ?? true,
    theme: "light",
    transition: option.transition || Slide,
    className: `custom-toast ${type}`,
    icon: false,
   ...(toastId && { toastId }),
  };

  if (newToastId && toast.isActive(newToastId)) {
    toast.update(newToastId, { render: toastContent, type: type as TypeOptions, autoClose: option.autoClose});
    return newToastId;
  }
  
  switch (type) {
    case "success":
      newToastId = toast.success(toastContent, toasterProps);
      break;
    case "error":
      newToastId = toast.error(toastContent, toasterProps);
      break;
    case "warning":
      newToastId = toast.warning(toastContent, toasterProps);
      break;
    case "clear":
      if (newToastId){
        toast.dismiss(newToastId);
      } else {
        toast.dismiss();
      }
      break;
    default:
      newToastId = toast(toastContent, toasterProps);
      break;
  }
  return newToastId;
};

export { FoundationsGenericToaster, ToastContainer };